import { EnvironmentInfo } from './auditEventTypes';

export interface IEnvironmentAuditDataProvider {
    getEnvironmentInfo(): EnvironmentInfo;
}

/**
 * Provider that reads environment information from the Office JavaScript API.
 */
export class OfficeJsEnvironmentInfoProvider implements IEnvironmentAuditDataProvider {
    getEnvironmentInfo(): EnvironmentInfo {
        // Office.Diagnostics and Office.Platform are available in modern Office.js hosts.
        const host = Office?.context?.diagnostics?.host?.toString() || 'unknown';
        const platform = Office?.context?.diagnostics?.platform?.toString() || 'unknown';
        const version = Office?.context?.diagnostics?.version?.toString() || 'unknown';

        return { Host: host, Platform: platform, Version: version };
    }
}
